const INITIAL_NUMBER_OF_OPTIONS = 10;

const COLOR_SWATCH_BUTTON_DIAMETER = 20;

export { COLOR_SWATCH_BUTTON_DIAMETER, INITIAL_NUMBER_OF_OPTIONS };
